import { useCurrentUser } from '../../../modules/context/UserContext'
import urls from '../../../modules/urls'
import useAppRouter from './useAppRouter'
import useSessionStorage from './useSessionStorage'

const useTypeQuery = () => {
  const router = useAppRouter()
  const { currentUser } = useCurrentUser()
  const typeQuery = router?.query?.type && router.query.type
  const [prevPage, setPrevPage] = useSessionStorage('prevPage', null)

  const handleExit = (defaultUrl?: any) => {
    let isPrevPageDashboard = false
    if (typeof window !== 'undefined') {
      // 간헐적으로 작동하지 않음
      isPrevPageDashboard = prevPage?.includes('dashboard')
    }

    if (isPrevPageDashboard) {
      router.back()
    } else {
      if (typeQuery == 'home') {
        router.push(urls.student.newPortal.home)
        return
      }
      if (typeQuery == 'caf') {
        router.push(urls.student.portal.lessons.review)
      }
      router.back()
    }
  }

  return { typeQuery, handleExit }
}

export default useTypeQuery
